import { Controller } from '@hotwired/stimulus'
// `intlTelInputWithUtils` bundles libphonenumber's utils synchronously, so
// getNumber() can format/validate immediately. The plain `intl-tel-input`
// entry would need the v28 `loadUtils` option (async) for getNumber() to work.
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils'

export default class extends Controller {
  static targets = ['input']

  connect() {
    this.iti = intlTelInput(this.inputTarget, {
      initialCountry: 'fr',
      countryOrder: ['fr'],
      nationalMode: false,
      separateDialCode: true
    })
  }

  disconnect() {
    if (this.iti) {
      this.iti.destroy()
      this.iti = null
    }
  }

  // Rewrites the field with the full international number (dial code included)
  // before submit — separateDialCode keeps the indicatif out of the visible
  // input, so getNumber() is what carries it into the params.
  formatNumber() {
    this.inputTarget.value = this.iti.getNumber()
  }
}
